import React, {useState} from 'react';
import api from '../services/api';
import {login} from '../auth';
import {useNavigate, useSearchParams, Link, useLocation} from 'react-router-dom';
import { getCurrentUserRole } from '../utils/authHelper';
import '../styles/LoginPage.css';

export default function Login() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [searchParams] = useSearchParams();
    const sessionExpired = searchParams.get('session') === 'expired';
    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname;

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            const res = await api.post('/auth/login', {username, password});
            login(res.data.token);
            if (res.data.must_change_password) {
                navigate('/change-password', { replace: true });
            } else if (from) {
                navigate(from, { replace: true });
            } else {
                const role = getCurrentUserRole();
                if (role === 'super_admin') navigate('/admin', { replace: true });
                else if (role === 'admin') navigate('/employee-hours', { replace: true });
                else navigate('/timetracking', { replace: true });
            }
        } catch (err) {
            const detail = err.response?.data?.detail;
            if (detail === 'EMAIL_NOT_VERIFIED') {
                setError('Bitte bestätigen Sie zuerst Ihre E-Mail-Adresse. Prüfen Sie Ihren Posteingang.');
            } else {
                setError('Benutzername oder Passwort ist falsch.');
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-container">
            <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 8, textDecoration: 'none', marginBottom: 24 }}>
                <span style={{ width: 8, height: 8, borderRadius: '50%', background: 'var(--color-primary)', display: 'inline-block' }} />
                <span style={{ fontWeight: 700, fontSize: 18, color: 'var(--color-text)' }}>Scalewisp</span>
            </Link>
            <h2 style={{ margin: '0 0 4px', fontSize: 22, fontWeight: 800, letterSpacing: '-0.01em' }}>Willkommen zurück</h2>
            <p style={{ margin: '0 0 24px', color: 'var(--color-text-secondary)', fontSize: 14 }}>Melden Sie sich mit Ihrem Konto an.</p>
            {sessionExpired && (
                <p data-testid="session-expired-message" style={{ margin: '0 0 16px', padding: '10px 14px', background: '#FEF3C7', color: '#92400E', borderRadius: 6, fontSize: 13 }}>
                    Deine Sitzung ist abgelaufen. Bitte melde dich erneut an.
                </p>
            )}
            <form onSubmit={handleSubmit} className="login-form">
                <label style={{ display: 'block', fontSize: 13, fontWeight: 600, marginBottom: 4, color: 'var(--color-text)' }}>
                    Benutzername
                </label>
                <input
                    data-testid="login-username"
                    type="text"
                    placeholder="Benutzername"
                    value={username}
                    onChange={e => setUsername(e.target.value)}
                    className="login-input"
                />
                <label style={{ display: 'block', fontSize: 13, fontWeight: 600, marginBottom: 4, marginTop: 12, color: 'var(--color-text)' }}>
                    Passwort
                </label>
                <input
                    data-testid="login-password"
                    type="password"
                    placeholder="Passwort"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    className="login-input"
                />
                <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: -4, marginBottom: 4 }}>
                    <Link to="/forgot-password" style={{ fontSize: 12, color: 'var(--color-primary)', textDecoration: 'none', fontWeight: 500 }}>
                        Passwort vergessen?
                    </Link>
                </div>
                <button data-testid="login-submit" className="button" type="submit" disabled={loading}
                    style={{ background: 'var(--color-primary)', color: '#fff', padding: '10px', fontWeight: 600, fontSize: 15, borderRadius: 8 }}>
                    {loading ? 'Wird angemeldet…' : 'Anmelden'}
                </button>
                {error && <p data-testid="login-error" className="login-error">{error}</p>}
            </form>
            <p style={{ textAlign: 'center', marginTop: 20, fontSize: 13, color: 'var(--color-text-secondary)' }}>
                Noch kein Konto? <Link to="/register" style={{ color: 'var(--color-primary)', fontWeight: 600, textDecoration: 'none' }}>Registrieren</Link>
            </p>
        </div>
    );
}
